import { MaskedPattern } from 'imask';
export const numberMask = {
  mask: Number,
  min: 0,
  signed: false,
  scale: 2,
  radix: '.'
};

export const numberCMask = {
  mask: Number,
  min: 0,
  signed: false,
  thousandsSeparator: ',',
  scale: 2,
  radix: '.'
};

export const numberPMask = {
  mask: Number,
  min: 0,
  signed: false,
  thousandsSeparator: ',',
  scale: 2,
  radix: '.',
  max: 100
};

export const numberIntMask = {
  mask: Number,
  min: 0,
  signed: false,
  scale: 0,
  max: 100
};

export const phoneMask = {
  mask: '(000) 000 0000'
};

export const cellularMask = {
  mask: '(000) 000 0000'
};

export const ciiuMask = {
  mask: Number,
  scale: 0,
  min: 0,
  max: 9999
};

export const licensePlateMask = {
  mask: /^[a-zA-Z]{1,3}[-]{0,1}[0-9]{0,3}$/
};

export const currencyMask = {
      mask: Number,
      min: 0,
      signed: false,
      thousandsSeparator: ',',
      scale: 2,
      radix: '.'
};

export const heightMask = {
  mask: Number,
      min: 0,
      max: 3,
      signed: false,
      scale: 2,
      radix: '.'
}

export const weightMask = {
  mask: Number,
      min: 0,
      max: 700,
      signed: false,
      scale: 3,
      radix: '.'
}

export const nameMask = {
  mask: /^[A-Za-zÑñÁáÉéÍíÓóÚúÜü]([A-Za-zÑñÁáÉéÍíÓóÚúÜü ]*){1,}$/
}

export const wordMask = {
  mask: /^\S.*$/
}

export const onlyNumberMask = {
  mask: /^[0-9]{0,}$/
}

export const passwordPattern = '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[-+_!@#$%^&*/ÑñÁáÉéÍíÓóÚúÜü., ?]).+$'

export const quotaMask = {
  mask: /^[0-9]{0,10}[-]{0,1}[0-9]{0,1}$/
}

export const contractMask = {
  mask: /^[0-9]{0,3}[-]{0,1}[0-9]{0,7}$/
}

export const vehLineMask = {
  mask: /^[0-9A-Za-zÑñÁáÉéÍíÓóÚúÜü]([0-9A-Za-zÑñÁáÉéÍíÓóÚúÜü ]*){1,50}$/
}

export const vinMask = {
  mask: /^[0-9A-Za-zÑñÁáÉéÍíÓóÚúÜü]{0,17}$/
}

export const alphanumericMask = {
  mask: /^[0-9A-Za-zÑñÁáÉéÍíÓóÚúÜü]([0-9A-Za-zÑñÁáÉéÍíÓóÚúÜü ]*){1,}$/
}
